import type { ActiveBenefits } from "@/types/loyalty-benefits"
import { atom } from "jotai"

/**
 * The merchant's active loyalty benefit mechanics, loaded once at hydration.
 * Used to highlight trigger items in the storefront (e.g. free-shipping badge).
 */
export const activeBenefitsAtom = atom<ActiveBenefits | null>(null)
